/**
 * Returns a new array containing only the unique elements from the input array.
 *
 * @typeParam T - The type of elements in the input array.
 * @param arr - The array from which to extract unique elements.
 * @returns A new array with duplicate elements removed, preserving the original order of first occurrence.
 */
export function unique<T>(arr: T[]): T[] {
    return Array.from(new Set(arr));
}
